import React, {Component} from 'react'
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {arrayMove} from 'react-sortable-hoc';
import * as callForApplicationAction from '../../actions/callForApplicationAction';
import Basket from './Basket';
import ResidentialMarketFilter from './ResidentialMarketFilter';
import MapWithPopUp from './MapWithPopUp';
import ResidentialMarketRow from './ResidentialMarketRow';
import moment from 'moment'
require('moment/locale/de')

// Decorate the class.
@withTranslation()
@connect(
	state => ({ // mapStateToProps
		currentCallForApplication: state.callForApplication.current
	}),
	{
		fetchCurrentCallForApplication: callForApplicationAction.fetchCurrent
	}
)
export default class ResidentialMarketList extends Component {

	/**
	 * @param {object} props
	 */
	constructor(props) {
		super(props)

		this.state = {
			filterRoom: '',
			filterResidentialArea: '',
			callForApplicationItems: [],
			isLoaded: false,
      hasError: false,
		}

		this.addToBasket = this.addToBasket.bind(this)
		this.isBasketFull = this.isBasketFull.bind(this)
		this.isInBasket = this.isInBasket.bind(this)
		this.getPositionInBasket = this.getPositionInBasket.bind(this)
		this.movePositionInBasket = this.movePositionInBasket.bind(this)
		this.removeFromBasket = this.removeFromBasket.bind(this)
		this.retrieveItem = this.retrieveItem.bind(this)
		this.handleFilterRoomChange = this.handleFilterRoomChange.bind(this)
		this.handleFilterResidentialAreaChange = this.handleFilterResidentialAreaChange.bind(this)
		this.filterCallForApplicationItems = this.filterCallForApplicationItems.bind(this)
	}

	/**
	 * @return {object|null}
	 */
	retrieveItem(callForApplicationItem) {
		var foundItem = null
		this.props.currentCallForApplication.callForApplicationItems.map(_callForApplicationItem => {

			if (_callForApplicationItem.__identity === callForApplicationItem.__identity) {
				foundItem = _callForApplicationItem;
			}
		})

		return foundItem;
	}

	/**
	 * @return void
	 */
	componentDidMount() {
		const specialCallForApplicationIdentifier = AblCh.callForApplicationIdentifier;

		this.props.fetchCurrentCallForApplication(specialCallForApplicationIdentifier)
			.then(callForApplication => {
				if (callForApplication) {
					const key = this.getStorageKey()
					const callForApplicationItemsFromStorage = localStorage.getItem(key)
						? JSON.parse(localStorage.getItem(key))
						: []

					const callForApplicationItems = []
					callForApplicationItemsFromStorage.map(callForApplicationItem => {
						const retrievedCallForApplicationItem = this.retrieveItem(callForApplicationItem)
						if (retrievedCallForApplicationItem) {
							callForApplicationItems.push(retrievedCallForApplicationItem)
						}
					})
          const applicationStatus = this.props.currentCallForApplication.status;
          const applicationIsRunning = applicationStatus === 'applicationOpen' && moment().isBetween(this.props.currentCallForApplication.publicationDate, this.props.currentCallForApplication.applicationDeadline);
          this.setState({applicationStatus: applicationStatus});
          this.setState({applicationIsRunning: applicationIsRunning});

					this.saveStateInLocalStorage(callForApplicationItems)
					this.setState({callForApplicationItems: callForApplicationItems})
				}
				this.setState({isLoaded: true})
			})
      .catch(error => {
        this.setState({hasError: true})
        this.setState({error: 'An unexpected error occurred. Please try again later.', isLoaded: true})
      })

	}

	/**
	 * @return void
	 */
	handleFilterRoomChange(event) {
		this.setState({filterRoom: event.target.value})
	}

	/**
	 * @return void
	 */
	handleFilterResidentialAreaChange(eventOrResidentialAreaIdentifier) {
		const residentialArea =  typeof eventOrResidentialAreaIdentifier === 'number'
			? eventOrResidentialAreaIdentifier
			: eventOrResidentialAreaIdentifier.target.value
		this.setState({filterResidentialArea: residentialArea})
	}

	/**
	 * @param {object} callForApplicationItems
	 */
	saveStateInLocalStorage(callForApplicationItems) {
		localStorage.setItem(this.getStorageKey(), JSON.stringify(callForApplicationItems)) // persist in localStorage
	}

	/**
	 * @param {int} oldIndex
	 * @param {int} newIndex
	 */
	movePositionInBasket(oldIndex, newIndex) {
		const callForApplicationItems = this.state.callForApplicationItems
		const callForApplicationItemsWithNewOrder = arrayMove(callForApplicationItems, oldIndex, newIndex)
		this.setState({callForApplicationItems: callForApplicationItemsWithNewOrder})
		this.saveStateInLocalStorage(callForApplicationItemsWithNewOrder)
	}

	/**
	 * @returns {string}
	 */
	getStorageKey() {
		return `AblBackoffice.${this.props.currentCallForApplication.__identity}.callForApplicationItems`
	}

	/**
	 * @param callForApplicationItem
	 */
	addToBasket(callForApplicationItem) {
		const callForApplicationItems = this.state.callForApplicationItems
		const maximumNumberOfItemsInBasket = AblCh.maximumNumberOfItemsInBasket;
		if (callForApplicationItems.length <= maximumNumberOfItemsInBasket) {
			callForApplicationItems.push(callForApplicationItem)
			this.setState({callForApplicationItems: callForApplicationItems})
			this.saveStateInLocalStorage(callForApplicationItems)
		}
	}

	/**
	 * @param callForApplicationItem
	 * @returns {boolean}
	 */
	isInBasket(callForApplicationItem) {
		return this.getPositionInBasket(callForApplicationItem) > -1;
	}

	/**
	 *
	 * @param callForApplicationItem
	 * @returns {number}
	 */
	getPositionInBasket(callForApplicationItem) {
		let position = -1
		this.state.callForApplicationItems.map((item, index) => {
			if (item.__identity === callForApplicationItem.__identity) {
				position = index;
			}
		})
		return position
	}

	/**
	 * @param callForApplicationItem
	 */
	removeFromBasket(callForApplicationItem) {
		const position = this.getPositionInBasket(callForApplicationItem)
		const callForApplicationItems = this.state.callForApplicationItems
		callForApplicationItems.splice(position, 1)
		this.setState({callForApplicationItems: callForApplicationItems})
		this.saveStateInLocalStorage(callForApplicationItems)
	}

	/**
	 * @returns {boolean}
	 */
	isBasketFull() {
		const maximumNumberOfItemsInBasket = AblCh.maximumNumberOfItemsInBasket;
		return this.state.callForApplicationItems.length >= maximumNumberOfItemsInBasket;
	}

	/**
	 * @param {Array} callForApplicationItems
	 * @returns {Array}
	 */
	filterCallForApplicationItems(callForApplicationItems) {
		return callForApplicationItems.filter(callForApplicationItem => {

			if (this.state.filterRoom) {
				const [minimum, maximum] = this.state.filterRoom.split('-')

				if (!(parseFloat(callForApplicationItem.realEstateObject.rooms) >= parseFloat(minimum)
					&& parseFloat(callForApplicationItem.realEstateObject.rooms) <= parseFloat(maximum))) {
					return
				}
			}

			if (AblCh.showForResidentialArea > 0) {
				if (callForApplicationItem.realEstateObject.residentialArea != AblCh.showForResidentialArea) {
					return
				}
			}

			if (this.state.filterResidentialArea) {
				if (callForApplicationItem.realEstateObject.residentialArea != this.state.filterResidentialArea) {
					return
				}
			}

			// the item is part of the set and can be safely returned
			return callForApplicationItem
		})
	}

	/**
	 * Group array to arrays having an array of common properties
	 * Source: http://codereview.stackexchange.com/questions/37028/grouping-elements-in-array-by-multiple-properties
	 *
	 * @param array
	 * @param f
	 * @returns {Array}
	 */
	groupBy(array, f) {
		var groups = {};
		array.forEach(function(o) {
			var group = JSON.stringify(f(o))
			groups[group] = groups[group] || []
			groups[group].push(o)
		})
		return Object.keys(groups).map(function(group) {
			return groups[group]
		})
	}

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		const {t} = this.props;
		const specialCallForApplicationIdentifier = AblCh.callForApplicationIdentifier;
		const isSpecialApplication = AblCh.isSpecialCallForApplication;
		const hasForm = AblCh.hasForm;

    if (this.state.isLoaded === false) {
      return <div className="alert alert-success">Bitte warten...</div>;
    } else if (this.state.hasError === true) {
      return <div className="alert alert-warning">Der Wohnungsmarkt kann momentan nicht abgerufen werden.</div>;
    } else if (this.props.currentCallForApplication === null || !this.props.currentCallForApplication.callForApplicationItems) {
      let currentCallForApplication = this.props.currentCallForApplication;
      return (
        <div>
          {
            !specialCallForApplicationIdentifier && AblCh.isInBackend === false &&
            <MapWithPopUp handleFilterResidentialAreaChange={this.handleFilterResidentialAreaChange} />
          }
          { AblCh.isInBackend === false &&
            <div className="alert alert-warning">
              <span>Im Moment sind keine Bewerbungen möglich, da keine Ausschreibung aktiv ist.</span>
              { (currentCallForApplication && typeof currentCallForApplication === 'object' && 'nextCallForApplicationPublicationDate' in currentCallForApplication) &&
                <span>&nbsp;Die nächste Ausschreibung startet am <strong>{moment(currentCallForApplication.nextCallForApplicationPublicationDate).format('D. MMMM YYYY')}, mittags</strong>.</span>
              }
            </div>
          }
          { AblCh.isInBackend && isSpecialApplication === true  && hasForm === true &&
            <div className="alert alert-warning">
              <span>Die Ausschreibung {specialCallForApplicationIdentifier} ist nicht vorhanden, oder wurde nicht als Spezialausschreibung markiert.</span>
            </div>
          }
          { AblCh.isInBackend && isSpecialApplication === undefined &&
            <div className="alert alert-warning">
              <span>Es ist keine reguläre Ausschreibung aktiv.</span>
            </div>
          }
        </div>
      );
    }

    const filteredCallForApplicationItems = this.filterCallForApplicationItems(this.props.currentCallForApplication.callForApplicationItems);
    const groupedCallForApplicationItems = this.groupBy(filteredCallForApplicationItems, function(item) {
      return [item.availableFrom];
    });

    return (
      <div>
        {
          !specialCallForApplicationIdentifier && AblCh.isInBackend === false &&
          <MapWithPopUp handleFilterResidentialAreaChange={this.handleFilterResidentialAreaChange} />
        }

          {this.props.currentCallForApplication && AblCh.isInBackend &&
            <div className="alert alert-warning neos-backend-box-settings mt-0">
              <p>
                Backoffice: <strong>{this.props.currentCallForApplication.title}</strong><br />
                Ausschreibungs-ID: <strong>{this.props.currentCallForApplication.callForApplicationIdentifier}</strong><br />
                Status: <strong>{this.props.currentCallForApplication.status}</strong><br />
                Start {moment(this.props.currentCallForApplication.publicationDate).format('dddd, D. MMMM YYYY, H.mm')} Uhr.<br />
                Ende {moment(this.props.currentCallForApplication.applicationDeadline).format('dddd, D. MMMM YYYY, H.mm')} Uhr.
              </p>
            </div>
          }

        { this.state.applicationIsRunning &&
          <div className="alert alert-warning">
            <span>Die Bewerbungsfrist läuft bis {moment(this.props.currentCallForApplication.applicationDeadline).format('dddd, D. MMMM YYYY, H.mm')} Uhr.</span>
          </div>
        }

        { this.state.applicationIsRunning === false &&
          <div className="alert alert-danger">
            <span>Die Bewerbung ist nicht möglich.<br/>
              Bewerbungfrist vom {moment(this.props.currentCallForApplication.publicationDate).format('dddd, D. MMMM YYYY, H.mm')} Uhr
              bis {moment(this.props.currentCallForApplication.applicationDeadline).format('dddd, D. MMMM YYYY, H.mm')} Uhr.
            </span>
          </div>
        }

        {
				  this.state.callForApplicationItems.length > 0 &&
				  <Basket items={this.state.callForApplicationItems}
                  movePositionInBasket={this.movePositionInBasket}
                  removeFromBasket={this.removeFromBasket}/>
				}

        <ResidentialMarketFilter
					{...this.props}
					{...this.state}
					handleFilterRoomChange={this.handleFilterRoomChange}
					handleFilterResidentialAreaChange={this.handleFilterResidentialAreaChange}
					filteredCallForApplicationItems={filteredCallForApplicationItems}/>

				{groupedCallForApplicationItems && groupedCallForApplicationItems.map(callForApplicationItemGroup => {
					return (
						callForApplicationItemGroup.map((callForApplicationItem, index) => {
							return (
								<ResidentialMarketRow key={callForApplicationItem.__identity}
								                      itemIndex={index}
								                      callForApplicationItem={callForApplicationItem}
								                      isInBasket={this.isInBasket}
								                      applicationIsRunning={this.state.applicationIsRunning}
								                      removeFromBasket={this.removeFromBasket}
								                      isBasketFull={this.isBasketFull}
								                      addToBasket={this.addToBasket}/>
							)
						})
					)
				})}
			</div>
		)
	}
}
